<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";
import VueNativeSock from "vue-native-websocket";
import config from "@/config/config";
import axios from "axios";

export default {
  data() {
    return {
      reconnect: true,
      reconnectAttempts: 0,
      tokenRenewTimeOut: 0
    };
  },

  computed: {
    isConnected() {
      return this.$store.getters.isConnected;
    },
    getLocation() {
      return this.$store.getters.getSettings.localization;
    }
  },


  methods: {
    onMessage(msg) {
      try {
        const wsMessage = JSON.parse(msg.data);
        //console.log("WebSocket msg: ", wsMessage);

        if (wsMessage.status === "FAIL") {
          this.reconnect = false;

          switch (wsMessage.code) {
            case 701:
            case 702:
            case 703:
            case 704:
              this.$store.commit("Logout");
              this.$router.push({ path: "/login" });
              break;
          }
        } else {
            if (wsMessage.topic == "onNewMessage") {
              this.$store.commit("setDataMessage", wsMessage);
            } 
        }
      } catch (err) {
        //console.log("Error parsing message from WS");
        console.log(err);
      }
    },

    onOpenWS() {
      this.$store.commit("setConnected", true);
    },

    onWSClose() {
      Vue.prototype.$disconnect();
      this.$store.commit("setConnected", false);
      if (this.reconnect) {
        setTimeout(() => {
          this.WSReconnect();
        }, 15000);
      }
    },

    WSReconnect() {
      if (!this.isConnected) {
        if (this.reconnectAttempts < config.websocket.reconnectAttempts) {
          Vue.prototype.$connect(this.$ENDPOINTS.API_WS);
          Vue.prototype.$socket.onopen = this.onOpenWS;
          Vue.prototype.$socket.onclose = this.onWSClose;
          Vue.prototype.$socket.onmessage = this.onMessage;

          this.reconnectAttempts++;
        }
      }
    }
  },

  created() {
    this.$lang.setLang(this.getLocation);

    if (!this.isConnected) {
      Vue.use(VueNativeSock, this.$ENDPOINTS.API_WS, {
        connectManually: true
      });

      Vue.prototype.$connect(this.$ENDPOINTS.API_WS);
      Vue.prototype.$socket.onopen = this.onOpenWS;
      Vue.prototype.$socket.onclose = this.onWSClose;
      Vue.prototype.$socket.onmessage = this.onMessage;
    }
  },

  beforeDestroy() {
    clearTimeout(this.tokenRenewTimeOut);
    this.reconnect = false;
    Vue.prototype.$disconnect();
    delete Vue.prototype.$socket;
    this.$store.commit("setConnected", false);
  }
};
</script>
